module.exports = __webpack_public_path__ + "assets/travelingAbroad_template-40a00c13c2ebc02a9908f9e599c8a4a7.xlsx";